import VueI18n from 'vue-i18n'
import Vue from 'vue'
Vue.use(VueI18n)

// todo get Naturo language
let i18n
const locale = window.localStorage.getItem('language')

switch (locale) {
  case 'en_US':
    // i18n = new VueI18n({
    //   locale,
    //   messages: { en_US: require('./lang/en').default }
    // })
    i18n = new VueI18n({
      locale: 'zh_CN',
      messages: { zh_CN: require('./lang/cn').default }
    })

    break

  default:
    if (locale != 'zh_CN') {
      localStorage.setItem('language', 'zh_CN')
    }
    i18n = new VueI18n({
      locale: 'zh_CN',
      messages: { zh_CN: require('./lang/cn').default }
    })
    break
}

export { i18n }
